const isCentrica = (organizationName?: string) => (
  organizationName?.toLowerCase() === "centrica"
);

export default isCentrica;
